import React from 'react';

export default function Badge({ variant = 'neutral', children }) {
  return <span className={`admin-badge ${variant}`}>{children}</span>;
}
